import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetDocImagePresignedURL = (caseId: string, docId: string, pageNumber: number) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery(
    [QueryEntity.PresignedGetDocumentImage, { docId, pageNumber }],
    async () => {
      try {
        const downloadResult = await fetch(
          `${APIBaseChronos}/api/case/${caseId}/docs/${docId}/image/${pageNumber}`,
          fetchConfigGET,
        );

        if (!downloadResult.ok) throw new Error('Fetching document url failed');

        return await downloadResult.text();
      } catch {
        return null;
      }
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 590 * 1000,
      cacheTime: 590 * 1000,
    },
  );
};
